export const ANSWER_OPTIONS = {
  GREATER_THAN: 'GREATER_THAN',
  LESSER_THAN: 'LESSER_THAN',
  EQUAL_TO: 'EQUAL_TO',
  HIGHEST_VALUE: 'HIGHEST_VALUE',
  LOWEST_VALUE: 'LOWEST_VALUE',
  SELECTED_VALUES: 'SELECTED_VALUES',
  UNSELECTED_VALUES: 'UNSELECTED_VALUES',
  VALUE: 'VALUE',
  VISIBLE_VALUES: 'VISIBLE_VALUES',
  HIDDEN_VALUES: 'HIDDEN_VALUES',
  SELECTED_COLUMNS: 'SELECTED_COLUMNS',
  UNSELECTED_COLUMNS: 'UNSELECTED_COLUMNS',
  SELECTED_FOR_ROW: 'SELECTED_FOR_ROW',
  UNSELECTED_FOR_ROW: 'UNSELECTED_FOR_ROW',
  SELECTED_FOR_COLUMN: 'SELECTED_FOR_COLUMN',
  UNSELECTED_FOR_COLUMN: 'UNSELECTED_FOR_COLUMN',
  ALL_VALUES: 'ALL_VALUES',
  ALL_ROWS: 'ALL_ROWS',
  ALL_COLUMNS: 'ALL_COLUMNS',
  ALL_ROWS_ALL_COLUMNS: 'ALL_ROWS_ALL_COLUMNS',
  SPECIFIC_SELECTED_VALUES: 'SPECIFIC_SELECTED_VALUES',
  SPECIFIC_UNSELECTED_VALUES: 'SPECIFIC_UNSELECTED_VALUES',
  SPECIFIC_SELECTED_COLUMNS: 'SPECIFIC_SELECTED_COLUMNS',
  SPECIFIC_UNSELECTED_COLUMNS: 'SPECIFIC_UNSELECTED_COLUMNS',
  VISIBLE_ROWS: 'VISIBLE_ROWS',
  HIDDEN_ROWS: 'HIDDEN_ROWS',
  VISIBLE_COLUMNS: 'VISIBLE_COLUMNS',
  HIDDEN_COLUMNS: 'HIDDEN_COLUMNS',
  // bipolar specifics
  MATRIX_EQUAL: 'MATRIX_EQUAL',
  MATRIX_HIGHEST_VALUE: 'MATRIX_HIGHEST_VALUE',
  MATRIX_LOWEST_VALUE: 'MATRIX_LOWEST_VALUE',
  MATRIX_GREATER_THAN: 'MATRIX_GREATER_THAN',
  MATRIX_EQUAL_GREATER_THAN: 'MATRIX_EQUAL_GREATER_THAN',
  MATRIX_NOT_EQUAL: 'MATRIX_NOT_EQUAL',
  MATRIX_EQUAL_LESSER_THAN: 'MATRIX_EQUAL_LESSER_THAN',
  MATRIX_LESSER_THAN: 'MATRIX_LESSER_THAN',
  MATRIX_SELECTED_FOR_ROW: 'MATRIX_SELECTED_FOR_ROW',
  MATRIX_ALL_ROWS: 'MATRIX_ALL_ROWS',
};

export const FORWARD_ANSWER_AS = {
  ANSWERS: 'answers',
  SCOREPOINTS: 'scorepoints',
};

export const BIPOLAR_LABEL_OPTIONS = {
  BOTH: 'BOTH',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const DEFAULT_MATRIX_ANSWER_AS = {
  [ANSWER_OPTIONS.ALL_ROWS_ALL_COLUMNS]: FORWARD_ANSWER_AS.ANSWERS,
  [ANSWER_OPTIONS.ALL_ROWS]: FORWARD_ANSWER_AS.ANSWERS,
  [ANSWER_OPTIONS.SELECTED_FOR_COLUMN]: FORWARD_ANSWER_AS.ANSWERS,
  [ANSWER_OPTIONS.UNSELECTED_FOR_COLUMN]: FORWARD_ANSWER_AS.ANSWERS,
  [ANSWER_OPTIONS.ALL_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.SELECTED_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.UNSELECTED_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.SPECIFIC_SELECTED_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.SPECIFIC_UNSELECTED_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.SELECTED_FOR_ROW]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.UNSELECTED_FOR_ROW]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.VISIBLE_ROWS]: FORWARD_ANSWER_AS.ANSWERS,
  [ANSWER_OPTIONS.HIDDEN_ROWS]: FORWARD_ANSWER_AS.ANSWERS,
  [ANSWER_OPTIONS.VISIBLE_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
  [ANSWER_OPTIONS.HIDDEN_COLUMNS]: FORWARD_ANSWER_AS.SCOREPOINTS,
};
